var map = {
	"./cell_quality.svg": 79031,
	"./cell_quality_selected.svg": 94861,
	"./cellular composition.svg": 26481,
	"./cellular_composition.svg": 24864,
	"./cellular_composition_selected.svg": 46188,
	"./differential expression.svg": 72424,
	"./differential_expression.svg": 51775,
	"./differential_expression_selected.svg": 20229,
	"./geneExpression.svg": 5792,
	"./geneExpressionSelected.svg": 25219,
	"./pathway_enrichment.svg": 20367,
	"./pathway_enrichment_selected.svg": 2869,
	"./recent_file.svg": 86133,
	"./recent_file_selected.svg": 54683,
	"./search.svg": 19221,
	"./search_selected.svg": 86715,
	"./venn.svg": 12362,
	"./venn_selected.svg": 50670
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 23254;